import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#424242",
  "fill-rule": "evenodd",
  d: "M14.973 11.797V7.588l-5.699 3.094a1.3 1.3 0 0 1-1.295 0L2.247 7.557a.66.66 0 0 1-.265-.257.7.7 0 0 1-.08-.335q0-.185.08-.335a.66.66 0 0 1 .265-.256L7.98 3.252a1.3 1.3 0 0 1 1.295.004l6.466 3.517q.171.086.264.248a.7.7 0 0 1 .094.35v4.426a.54.54 0 0 1-.162.4.55.55 0 0 1-.4.162.54.54 0 0 1-.402-.161.55.55 0 0 1-.161-.401zm-6.994 2.945L4.46 12.84a1.35 1.35 0 0 1-.52-.507 1.35 1.35 0 0 1-.187-.695v-2.59l4.227 2.29a1.3 1.3 0 0 0 1.295 0l4.228-2.29v2.592q0 .375-.189.695a1.36 1.36 0 0 1-.52.505l-3.519 1.902a1.28 1.28 0 0 1-.98.13 1.4 1.4 0 0 1-.315-.13z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }